import { api } from "./api";
import type { Alert, AlertSnooze } from "@/types/models";

export interface SnoozePayload {
  rule_id: string;
  flock_id?: number;
  label: string;
  days?: number; // omitted/0 = indefinite (until unsnoozed)
}

export const alertsService = {
  // Lazy-on-read "needs attention" list for the owner dashboard (Phase 4 slice 1).
  getAlerts: (): Promise<Alert[]> => api.get<Alert[]>("/alerts").then((r) => r.data),
  // Email the current digest to the calling owner now (Farm Settings test button).
  sendTestDigest: (): Promise<void> => api.post("/alerts/digest/test").then(() => undefined),
  // Mute an alert so it stops surfacing on the dashboard and in the digest.
  snooze: (payload: SnoozePayload): Promise<void> => api.post("/alerts/snooze", payload).then(() => undefined),
  unsnooze: (rule_id: string, flock_id?: number): Promise<void> =>
    api.post("/alerts/unsnooze", { rule_id, flock_id }).then(() => undefined),
  getSnoozed: (): Promise<AlertSnooze[]> => api.get<AlertSnooze[]>("/alerts/snoozed").then((r) => r.data),
};
